// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 数据类型枚举 枚举类
 * 数据类型枚举
 */
export enum EnumDataType {
  /** 布尔型 : 布尔型 */
  Bool = 1,
  /** 单行字符串 : 单行字符串 */
  String = 2,
  /** 多行字符串 : 多行字符串 */
  Text = 4,
  /** 富文本 : 富文本 */
  Richtext = 8,
  /** 16位整型 : 16位整型 */
  Short = 16,
  /** 32位整型 : 32位整型 */
  Int = 32,
  /** 64位整型 : 64位整型 */
  Long = 64,
  /** 时间日期型 : 时间日期型 */
  DateTime = 128,
  /** 日期型 : 日期型 */
  Date = 256,
  /** 时间型 : 时间型 */
  Time = 512,
  /** 单精度数值型 : 单精度数值型 */
  Float = 1024,
  /** 双精度数值型 : 双精度数值型 */
  Double = 2048,
  /** 金额数值型 : 金额数值型 */
  Money = 4096,
  /** GUID : GUID */
  Guid = 8192,
  /** 跨应用引用类型 : 跨应用引用类型 */
  UniqueKey = 16384,
  /** 应用内引用类型 : 应用内引用类型 */
  Reference = 32768
}

/**
 * 数据类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumDataTypeMD {
  private static items = [
    new EnumItemMD('Bool', 1, '布尔型', '布尔型'),
    new EnumItemMD('String', 2, '单行字符串', '单行字符串'),
    new EnumItemMD('Text', 4, '多行字符串', '多行字符串'),
    new EnumItemMD('Richtext', 8, '富文本', '富文本'),
    new EnumItemMD('Short', 16, '16位整型', '16位整型'),
    new EnumItemMD('Int', 32, '32位整型', '32位整型'),
    new EnumItemMD('Long', 64, '64位整型', '64位整型'),
    new EnumItemMD('DateTime', 128, '时间日期型', '时间日期型'),
    new EnumItemMD('Date', 256, '日期型', '日期型'),
    new EnumItemMD('Time', 512, '时间型', '时间型'),
    new EnumItemMD('Float', 1024, '单精度数值型', '单精度数值型'),
    new EnumItemMD('Double', 2048, '双精度数值型', '双精度数值型'),
    new EnumItemMD('Money', 4096, '金额数值型', '金额数值型'),
    new EnumItemMD('Guid', 8192, 'GUID', 'GUID'),
    new EnumItemMD('UniqueKey', 16384, '跨应用引用类型', '跨应用引用类型'),
    new EnumItemMD('Reference', 32768, '应用内引用类型', '应用内引用类型')
  ];

  static getItem(enumItem: EnumDataType) {
    return this.items.find(item => item.name === EnumDataType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
